// extracted by mini-css-extract-plugin
export default {"container":"Incident_container__0qaNs","page":"Incident_page__G08cw","section":"Incident_section__lBvNS"};